<template>
  <basic-container>
    <avue-crud :option="option"
               :data="data"
               :page.sync="page"
               ref="crud"
               @row-del="rowDel"
               v-model="form"
               :permission="permissionList"
               @row-update="rowUpdate"
               @row-save="rowSave"
               :before-open="beforeOpen"
               @search-change="searchChange"
               @search-reset="searchReset"
               @refresh-change="refreshChange"
               @selection-change="selectionChange"
               @on-load="onLoad">
      <template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permission.health_bsmeterweek_delete"
                   @click="handleDelete">删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getList, getDetail, submit, remove } from '@/api/health/bsmeterweek'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      option: {
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        column: [
          {
            label: '主键',
            prop: 'id',
            rules: [{
              required: true,
              message: '请输入主键'
            }]
          },
          {
            label: 'appUserId',
            prop: 'wxUserId',
            rules: [{
              required: true,
              message: '请输入appUserId'
            }]
          },
          {
            label: '乐观锁',
            prop: 'year',
            rules: [{
              required: true,
              message: '请输入乐观锁'
            }]
          },
          {
            label: '乐观锁',
            prop: 'week',
            rules: [{
              required: true,
              message: '请输入乐观锁'
            }]
          },
          {
            label: '空腹血糖平均值',
            prop: 'emptyStomach',
            rules: [{
              required: true,
              message: '请输入空腹血糖平均值'
            }]
          },
          {
            label: '餐后血糖平均值',
            prop: 'afterMeal',
            rules: [{
              required: true,
              message: '请输入餐后血糖平均值'
            }]
          },
          {
            label: '低血糖',
            prop: 'lowBloodSugar',
            rules: [{
              required: true,
              message: '请输入低血糖'
            }]
          },
          {
            label: '创建时间',
            prop: 'createTime',
            rules: [{
              required: true,
              message: '请输入创建时间'
            }]
          },
          {
            label: '修改时间',
            prop: 'updateTime',
            rules: [{
              required: true,
              message: '请输入修改时间'
            }]
          },
          {
            label: '乐观锁',
            prop: 'revision',
            rules: [{
              required: true,
              message: '请输入乐观锁'
            }]
          },
          {
            label: '是否是糖尿病，0不是，1是',
            prop: 'bsType',
            rules: [{
              required: true,
              message: '请输入是否是糖尿病，0不是，1是'
            }]
          },
          {
            label: '空腹达标率',
            prop: 'kfRate',
            rules: [{
              required: true,
              message: '请输入空腹达标率'
            }]
          },
          {
            label: '餐后达标率',
            prop: 'chRate',
            rules: [{
              required: true,
              message: '请输入餐后达标率'
            }]
          },
          {
            label: '低血糖达标率',
            prop: 'lbRate',
            rules: [{
              required: true,
              message: '请输入低血糖达标率'
            }]
          },
          {
            label: '空腹是否达标，0为达标满意，1为不达标不满意',
            prop: 'kfStatus',
            rules: [{
              required: true,
              message: '请输入空腹是否达标，0为达标满意，1为不达标不满意'
            }]
          },
          {
            label: '餐后是否达标，0为达标满意，1为不达标不满意',
            prop: 'chStatus',
            rules: [{
              required: true,
              message: '请输入餐后是否达标，0为达标满意，1为不达标不满意'
            }]
          },
          {
            label: '总达标，有糖尿病0为达标，1为不达标；无糖尿病0为正常血糖，1为血糖异常，2为糖尿病',
            prop: 'upToStandard',
            rules: [{
              required: true,
              message: '请输入总达标，有糖尿病0为达标，1为不达标；无糖尿病0为正常血糖，1为血糖异常，2为糖尿病'
            }]
          }
        ]
      },
      data: []
    }
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList () {
      return {
        addBtn: this.permission.health_bsmeterweek_add,
        viewBtn: this.permission.health_bsmeterweek_view,
        delBtn: this.permission.health_bsmeterweek_delete,
        editBtn: this.permission.health_bsmeterweek_edit
      }
    },
    ids () {
      const ids = []
      this.selectionList.forEach(ele => {
        ids.push(ele.id)
      })
      return ids.join(',')
    }
  },
  methods: {
    rowSave (row, done, loading) {
      submit(row).then(() => {
        done()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }).catch(() => {
        loading()
      })
    },
    rowUpdate (row, index, done, loading) {
      submit(row).then(() => {
        done()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }).catch(() => {
        loading()
      })
    },
    rowDel (row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return remove(row.id)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        })
    },
    searchReset () {
      this.onLoad(this.page)
    },
    searchChange (params, done) {
      this.onLoad(this.page, params)
      done()
    },
    selectionChange (list) {
      this.selectionList = list
    },
    refreshChange (data) {
      this.onLoad(this.page, data.searchForm)
    },
    handleDelete () {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据')
        return
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return remove(this.ids)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.$refs.crud.toggleSelection()
        })
    },

    beforeOpen (done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then(res => {
          this.form = res.data
        })
      }
      done()
    },
    onLoad (page, params = {}) {
      getList(page.currentPage, page.pageSize, params).then(res => {
        const data = res.data
        this.page.total = data.total
        this.data = data.records
      })
    }
  }
}
</script>
